export type ZoneNodeLevel = 'ZONE' | 'SECTION' | 'BLOCK' | 'PIT'

export type ZoneStatus = 'operational' | 'held' | 'evacuated'

export const ZONE_STATUS_COLORS: Record<ZoneStatus, string> = {
  operational: '#24D07B',
  held: '#F4D03F',
  evacuated: '#E74C3C',
}

export const ZONE_STATUS_LABELS: Record<ZoneStatus, string> = {
  operational: 'OPERATIONAL',
  held: 'HELD',
  evacuated: 'EVACUATED',
}

export interface IZoneTreeNode {
  id: string
  name: string
  level: ZoneNodeLevel
  status: ZoneStatus
  children?: IZoneTreeNode[]
}
